import * as React from 'react';
import { ReactNode, useCallback, useMemo } from 'react';

import { Box } from '@mui/material';

import { DatePicker, FormControllerTitle } from '@sbv-clients/ui-shared';

function useTransformDatePickerValue(onChange: (value: Date) => void) {
  return useCallback(
    (value: Date | null) => {
      const isValidDate =
        (value as any) instanceof Date && !isNaN((value as Date).getTime());

      if (value && isValidDate) {
        onChange(value);
      }
    },
    [onChange]
  );
}

const BaseDateFilter = ({
  label,
  value,
  onChange,
  error,
  helperText,
}: {
  label: string;
  value: Date | null;
  onChange: (value: Date) => void;
  error?: boolean;
  helperText?: ReactNode;
}) => {
  const handleChange = useTransformDatePickerValue(onChange);

  const updatedValue = useMemo(() => {
    if (!value) {
      return null;
    }
    return new Date(value);
  }, [value]);
  return (
    <Box>
      <FormControllerTitle>{label}</FormControllerTitle>
      <DatePicker
        value={updatedValue}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            error,
            helperText,
          },
        }}
        onChange={handleChange}
      />
    </Box>
  );
};

export default BaseDateFilter;
